<template>
    <v-ons-page>
        <ons-toolbar class="main-toolbar" v-bind:class="{ branded: embed.enabled }">
            <router-link tag="a" v-bind:to="{ name: 'SignUp' }" title="Signup" class="main-text left"
                         data-test-id="href-signup">
                Don't have an account? <span class="active-text">Sign Up</span>
            </router-link>
            <div class="right">
                <ons-toolbar-button>
                    <router-link v-bind:to="{ name: 'Outlets' }" v-bind:title="'Outlets'">
                        <i class="fal fa-times"/>
                    </router-link>
                </ons-toolbar-button>
            </div>
        </ons-toolbar>

        <div class="content main-background">

            <v-ons-progress-bar v-if="show_loading" indeterminate/>

            <div class="content-inner content-inner-fill">

                <div class="minheight-content-container">

                    <div class="main-header left mb-20 mt-10">
                        Welcome back! You've been missed
                    </div>

                    <form @submit.prevent="login">
                        <v-ons-list class="list-no-divider">
                            <v-ons-list-item>
                                <div class="center">
                                    <v-ons-input placeholder="Enter your email" float v-model="form.email" type="email"
                                                data-test-id="inp-email"/>
                                </div>
                            </v-ons-list-item>
                            <v-ons-list-item>
                                <div class="center">
                                    <v-ons-input placeholder="Password" float v-model="form.password" type="password"
                                                data-test-id="inp-password"/>
                                </div>
                            </v-ons-list-item>
                        </v-ons-list>
                        <!-- Fake submit button required to allow submit on enter behaviour. Not possible to add 'submit'
                                attribute to existing v-ons-button in the form -->
                        <input type="submit" style="position: absolute; left: -9999px"/>
                    </form>

                    <div class="minheight-content-spacer"></div>

                    <div class="min-height-content-bottom">
                        <gtc-button class="btn-action mb-16"
                                    v-on:click="login"
                                    v-bind:disabled="!can_login || logging_in"
                                    v-bind:in_progress="logging_in"
                                    data-test-id="btn-login">
                            Sign In
                        </gtc-button>
                        <gtc-button class="secondary mb-30" v-on:click="forgot" data-test-id="href-forgot-password">
                            Forgot password?
                        </gtc-button>
                        <login v-show="complete == false" v-bind:redirect="true" v-bind:social_only="true"/>
                    </div>

                </div>
            </div>

            <validation v-bind:show="validation.show"
                    v-bind:errors="validation.errors"
                    v-on:show="(show) => validation.show = show"></validation>

        </div>

    </v-ons-page>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    import { default as ValidationComponent } from '../fragments/validation'
    import { default as LoginComponent } from '../fragments/login'

    export default {

        mixins: [],

        components: {
            'validation': ValidationComponent,
            'login': LoginComponent,
        },

        mounted() {
            this.authRedirect()
        },

        data () {
            return {
                app: this.$root.$data.app,
                form: {
                    email: '',
                    password: '',
                },
                validation: {
                    show: false,
                    errors: null,
                },
                logging_in: false,
                message: '',
                complete: false,
            }
        },

        methods: {

            authRedirect() {
                if (this.$store.state.user !== null) {
                    this.$router.replace(this.app.homeRoute());
                }
            },

            login(){

                if (this.can_login == false)
                    return

                this.app.http.post('/jwt/authenticate', this.form)
                    .then(response => {
                        this.logging_in = false

                        this.$store.commit('login', response.data)
                        this.$router.push(this.app.homeRoute())
                    })
                    .catch(error => {
                        this.logging_in = false

                        if (error.response && error.response.data && error.response.data.errors) {
                            this.validation.errors = error.response.data.errors
                            this.validation.show = true
                        } else {
                            this.$ons.notification.alert(
                                this.app.getResponseErrorMessage(error),
                                { title: 'Unable to login' }
                            )
                        }
                    })
            },

            forgot(){
                this.$router.push({name: "ForgotPassword"})
            },
        },

        computed: {

            ...mapGetters([
                'embed',
            ]),

            show_loading: function(){
                return this.logging_in
            },

            show_login_google: function(){
                return (!!(window.env.google_client_key)) && !this.app_embed
            }, 

            show_login_facebook: function(){
                return (!!(window.env.facebook_app_id)) && !this.app_embed
            },

            can_login: function(){
                return this.form.email.length > 0 && this.form.password.length > 0
            },
        }
    }
</script>

<style scoped>
    .main-toolbar > a {
        max-width: 300px;
        padding-left: 30px;
    }

    .main-toolbar > a:visited {
        color: #4b4c4c;
    }
</style>



// WEBPACK FOOTER //
// src/js/components/user/login.vue